import React, { FC, useState } from 'react';
import { Modal, ModalContent, ModalTrigger } from '@fiverr-private/overlay';
import { Container } from '@fiverr-private/layout_components';
import { MODAL_STEPS } from './constants';
import { IModalStep, IRequestToUploadModalProps } from './types';
import { useAdminInfo } from './useAdminInfo';
import { SendRequestStep } from './SendRequestStep';
import { SuccessStep } from './SuccessStep';

export const modalSteps: IModalStep[] = [
    { modalStep: MODAL_STEPS.SEND_REQUEST, component: SendRequestStep },
    { modalStep: MODAL_STEPS.SUCCESS, component: SuccessStep },
];

export const RequestToUploadModal: FC<IRequestToUploadModalProps> = ({ children, biData, isOpen, onClose }) => {
    const [currentStep, setCurrentStep] = useState<number>(0);

    const { adminInfo } = useAdminInfo();

    const handleNextStep = (): void => {
        setCurrentStep((prevState) => prevState + 1);
    };

    const currentModalStep = modalSteps[currentStep];

    const CurrentModalStepComponent = currentModalStep.component;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalTrigger as="div">
                <Container width="100%">{children}</Container>
            </ModalTrigger>
            <ModalContent onAnimationEnd={() => setCurrentStep(0)}>
                <CurrentModalStepComponent biData={biData} adminInfo={adminInfo} onNextStep={handleNextStep} />
            </ModalContent>
        </Modal>
    );
};
